import { render, staticRenderFns } from "./FloatingPlayer.vue?vue&type=template&id=71c5914b&"
import script from "./FloatingPlayer.vue?vue&type=script&lang=js&"
export * from "./FloatingPlayer.vue?vue&type=script&lang=js&"
import style0 from "./FloatingPlayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FloatingPlayer.vue"
export default component.exports